import { motion } from "framer-motion";
import PageBanner from "@/components/public/PageBanner";
import VMCorporate from "@/components/landing/VMCorporate";
import { useMedia } from "@/context/MediaContext";
import { resolveImg } from "@/lib/api";

export default function CorporatePage() {
  const { banner_corporate, corporate_gallery } = useMedia();
  const gallery = (corporate_gallery || []).filter((g) => g && g.image);

  return (
    <>
      <PageBanner
        image={banner_corporate?.image}
        overline="VM Corporate"
        title={banner_corporate?.title}
        subtitle={banner_corporate?.subtitle}
      />

      {gallery.length > 0 && (
        <section className="py-14 sm:py-20 px-5 sm:px-8" data-testid="corporate-gallery-section">
          <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-4">
            {gallery.map((g, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="relative rounded-2xl overflow-hidden aspect-[4/5] group"
                data-testid={`corporate-gallery-${i}`}
              >
                <img src={resolveImg(g.image)} alt={g.label || "VM Corporate"} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                {g.label && <span className="absolute bottom-4 left-4 text-sm font-medium">{g.label}</span>}
              </motion.div>
            ))}
          </div>
        </section>
      )}

      <VMCorporate />
    </>
  );
}
